export default __webpack_public_path__ + "static/media/mercados.5ea4ff82.png";